<script setup lang="ts">
import { useUserStoreHook } from '@/store/modules/user'
import { useRouter } from 'vue-router'
import { Menu, SwitchButton, ArrowRight, User } from '@element-plus/icons-vue'
import { ref } from 'vue'
import { useDialog } from '@/utils/dialogUtils'
import BillingRules from '@/layout/components/BillingRules.vue'
import { CommonUtils } from '@/utils'
import { Navigation } from '@/utils/navigation'
import { UserRoleEnum } from '@/types/constantsEnum'
import { IconparkGift } from '@/components/Icon'
const billingRulesRef = ref()
const router = useRouter()
const isShow = ref(false)
let timeoutId: number | null = null
// 充值弹窗
const { showRechargeDialog } = useDialog()

const handleCommand = (command: string) => {
  switch (command) {
    case 'admin':
      const route = router.resolve({
        name: 'adminIndex',
      })
      Navigation.openBlank(route.href)

      break
    case 'logout':
      useUserStoreHook().logOut()
      router.push('/login')
      break
    case 'billingRules':
      billingRulesRef?.value.open()
      break
    case 'user':
      router.push('/user')
      break
    case 'share':
      router.push('/user?type=3')
      break
  }
}

const handleMouseEnter = () => {
  if (timeoutId) {
    window.clearTimeout(timeoutId)
    timeoutId = null
  }
  updateScore()
  isShow.value = true
}

const updateScore = CommonUtils.throttle(() => {
  useUserStoreHook().updateScore()
}, 3000)
const handleMouseLeave = () => {
  timeoutId = window.setTimeout(() => {
    isShow.value = false
    timeoutId = null
  }, 100)
}
const goUserCenter = (type: number) => {
  router.push('/user?type=' + type)
}
const handleRecharge = () => {
  showRechargeDialog()
}
</script>

<template>
  <div class="user-card-container">
    <!-- 头像触发器 -->
    <div class="hover-area" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <div class="avatar-wrapper">
        <div class="avatar-trigger" :class="{ 'avatar-move': isShow }">
          <div class="avatar-inner">
            <img
              :src="useUserStoreHook()?.avatar"
              alt="user"
              class="avatar-img credit-info"
              @click="goUserCenter(0)"
            />
          </div>
        </div>
      </div>

      <!-- 浮窗卡片 -->
      <Transition name="card">
        <div v-show="isShow" class="floating-card">
          <div class="card-content">
            <!-- 用户信息 -->
            <div class="user-info">
              <div class="avatar-placeholder credit-info"></div>
              <h3 class="username color-[#3D3D3D] text-size16 credit-info" @click="goUserCenter(0)">
                {{ useUserStoreHook()?.nickname || '未登录' }}
              </h3>
              <div class="flex items-center justify-center credit-info">
                <div class="flex items-center mt-[6px] justify-center" @click="goUserCenter(2)">
                  <span class="text-[#B5B5B5] text-size16">积分:</span>
                  <span class="text-[#0770ED] text-size16">{{
                    useUserStoreHook()?.scoreDetail.credit || '0'
                  }}</span>
                </div>
              </div>
              <!-- 充值按钮 -->

              <div
                class="w-full flex items-center justify-center text-size16 text-white h-[40px] rounded-[21px] mt-[16px] recharge-btn"
                @click="handleRecharge"
              >
                立即充值
              </div>
            </div>

            <!-- 菜单项 -->
            <div class="menu-items">
              <div class="menu-item" @click="handleCommand('user')">
                <div class="item-left">
                  <img src="@/assets/icon/user.png" alt="logout" class="w-[17px] h-[17px]" />
                  <span class="!text-[#3D3D3D] !text-size14">个人中心</span>
                </div>
                <img src="@/assets/icon/right_icon.png" alt="right" class="w-[17px] h-[17px]" />
              </div>
              <div class="menu-item" @click="handleCommand('share')">
                <div class="item-left">
                  <IconparkGift class="w-[17px] h-[17px]" />
                  <span class="!text-[#3D3D3D] !text-size14">分享有礼</span>
                </div>
                <img src="@/assets/icon/right_icon.png" alt="right" class="w-[17px] h-[17px]" />
              </div>
              <div class="menu-item" @click="handleCommand('billingRules')">
                <div class="item-left">
                  <img src="@/assets/icon/expenses.png" alt="logout" class="w-[17px] h-[17px]" />
                  <span class="!text-[#3D3D3D] !text-size14">计费规则</span>
                </div>
                <img src="@/assets/icon/right_icon.png" alt="right" class="w-[17px] h-[17px]" />
              </div>
              <div
                class="menu-item"
                @click="handleCommand('admin')"
                v-if="
                  useUserStoreHook().roles.includes(UserRoleEnum.Admin) ||
                  useUserStoreHook().roles.includes(UserRoleEnum.OperationStaff)
                "
              >
                <div class="item-left">
                  <el-icon><Menu /></el-icon>
                  <span>后台管理</span>
                </div>
                <img src="@/assets/icon/right_icon.png" alt="right" class="w-[17px] h-[17px]" />
              </div>
              <div
                class="menu-item !pt-[14px] mt-[12px] !pb-0 border-t border-solid border-[#D8D8D8]"
                @click="handleCommand('logout')"
              >
                <div class="item-left">
                  <img src="@/assets/icon/exit.png" alt="logout" class="w-[15px] h-[15px]" />
                  <span class="!text-[#8E8E93] !text-size14">退出登录</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Transition>
      <BillingRules ref="billingRulesRef" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.user-card-container {
  position: relative;
  display: inline-block;
}

.hover-area {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -20px;
    right: -20px;
    bottom: -20px;
    z-index: 999;
  }
}

.avatar-wrapper {
  position: relative;
  width: 32px;
  height: 32px;
}

.avatar-trigger {
  position: absolute;
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  left: 0;
  top: 0;

  .avatar-inner {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    // background: linear-gradient(45deg, var(--el-color-primary), var(--el-color-primary-light-5));
    // padding: 2px;
    opacity: 0.85;
    transition: all 0.3s ease;

    .avatar-img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      transition: all 0.3s ease;
      border: 2px solid white;
      background: white;
    }
  }

  &:hover {
    .avatar-inner {
      opacity: 1;
      transform: scale(1.1);
    }
  }

  &.avatar-move {
    width: 70px;
    height: 70px;
    top: calc(100% + 10px);
    transform: translateX(-110px);
    margin-top: -30px;
    z-index: 1001;

    .avatar-inner {
      opacity: 1;
      transform: none;
    }
  }
}

.floating-card {
  position: absolute;
  top: calc(100% + 10px);
  right: -28px;
  width: 278px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  transform-origin: top right;
  pointer-events: none;

  &::before {
    content: '';
    position: absolute;
    top: -8px;
    right: 116px;
    border-style: solid;
    border-width: 0 8px 8px 8px;
    border-color: transparent transparent white transparent;
  }

  .card-content {
    pointer-events: auto;
    .user-info {
      // width: 100%;
      padding: 0 20px;
      height: 182px;
      text-align: center;
      background-image: url('@/assets/img/user_card_bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;

      .avatar-placeholder {
        position: absolute;
        top: -35px;
        left: 50%;
        transform: translateX(-50%);
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }

      .username {
        font-size: 18px;
        padding-top: 45px;
        margin-bottom: 4px;
      }

      .user-id {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .recharge-btn {
      background: linear-gradient(202deg, #81daff 7%, #1767dd 94%);
      transition: all 0.2s ease;
      &:hover {
        transform: scale(1.05);
      }
    }

    .menu-items {
      padding: 12px 25px 30px 25px;

      .menu-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 7px 0;
        cursor: pointer;
        transition: all 0.2s ease;

        .item-left {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .el-icon {
          font-size: 16px;
          color: #666;
        }

        span {
          font-size: 14px;
          color: #333;
        }

        &:hover {
          transform: scale(1.05);
          color: var(--el-color-primary);

          .el-icon {
            color: var(--el-color-primary);
          }
          span {
            color: var(--el-color-primary);
          }
        }
      }
    }
  }
}
.credit-info {
  transition: all 0.2s ease;
  &:hover {
    transform: scale(1.05);
  }
}

// 优化卡片动画
.card-enter-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.card-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s cubic-bezier(0.4, 0, 1, 1);
}

.card-enter-from,
.card-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
